import React from "react";
import "./SurveyViewModal.css";

const SurveyViewModal = ({ visible, onClose, survey }) => {
  if (!visible || !survey) return null;
  const property = survey.property || {};
  const ownerFamily = survey.owner_family || [];
  const tenantFamily = survey.tenant_family || [];
  const totalPersons = survey.total_persons || 0;
  const totalWeapons = survey.total_weapons || 0;
  const status = survey.status || "-";

  // Font size tweaks for modal (now handled by CSS)

  return (
    <div className="survey-modal" role="dialog" aria-modal="true">
      <div className="survey-modal-overlay" onClick={onClose} />
      <div className="survey-modal-content">
        {/* Modal Header */}
        <div className="survey-modal-header">
          <h2>Survey Details</h2>
        </div>
        {/* Modal Body (scrollable) */}
        <div className="survey-modal-body">
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: 32,
              marginBottom: 32,
            }}
          >
            <section className="survey-modal-section">
              <h3 style={{ color: "#2563eb" }}>Property Details</h3>
              <table className="survey-modal-table">
                <tbody>
                  <tr>
                    <th>Property No</th>
                    <td>{property.property_no || "-"}</td>
                  </tr>
                  <tr>
                    <th>Address</th>
                    <td>{property.address_line || "-"}</td>
                  </tr>
                  <tr>
                    <th>City</th>
                    <td>{property.city || "-"}</td>
                  </tr>
                  <tr>
                    <th>Status</th>
                    <td>{property.status || "-"}</td>
                  </tr>
                  <tr>
                    <th>Created At</th>
                    <td>{property.created_at || "-"}</td>
                  </tr>
                  <tr>
                    <th>Updated At</th>
                    <td>{property.updated_at || "-"}</td>
                  </tr>
                </tbody>
              </table>
            </section>
            <section className="survey-modal-section">
              <h3 style={{ color: "#2563eb" }}>Survey Summary</h3>
              <table className="survey-modal-table">
                <tbody>
                  <tr>
                    <th>Total Persons</th>
                    <td>{totalPersons}</td>
                  </tr>
                  <tr>
                    <th>Total Weapons</th>
                    <td>{totalWeapons}</td>
                  </tr>
                  <tr>
                    <th>Status</th>
                    <td>{status}</td>
                  </tr>
                </tbody>
              </table>
            </section>
          </div>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr",
              gap: 32,
              marginBottom: 32,
            }}
          >
            <section className="survey-modal-section">
              <h3 style={{ color: "#059669" }}>Owner & Family</h3>
              {ownerFamily.length === 0 ? (
                <div>No owner family found.</div>
              ) : (
                <table className="survey-modal-table">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Role</th>
                      <th>CNIC</th>
                      <th>Phone</th>
                      <th>Age</th>
                      <th>Gender</th>
                      <th>Occupation</th>
                      <th>Income</th>
                      <th>Weapons</th>
                    </tr>
                  </thead>
                  <tbody>
                    {ownerFamily.map((person) => (
                      <tr key={person.id}>
                        <td>
                          {person.first_name} {person.middle_name}{" "}
                          {person.last_name}
                        </td>
                        <td>{person.role_in_property}</td>
                        <td>{person.cnic || "-"}</td>
                        <td>{person.phone_no || "-"}</td>
                        <td>{person.age}</td>
                        <td>{person.gender}</td>
                        <td>{person.occupation_title || "-"}</td>
                        <td>{person.monthly_income || "-"}</td>
                        <td>
                          {person.weapons && person.weapons.length > 0 ? (
                            <ul style={{ margin: 0, paddingLeft: 18 }}>
                              {person.weapons.map((w) => (
                                <li key={w.id} style={{ marginBottom: 4 }}>
                                  {w.type} ({w.license_no}){" "}
                                  {w.is_licensed ? "Licensed" : "Unlicensed"}{" "}
                                  {w.notes && `- ${w.notes}`}
                                </li>
                              ))}
                            </ul>
                          ) : (
                            "None"
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </section>
            <section className="survey-modal-section">
              <h3 style={{ color: "#059669" }}>Tenant & Family</h3>
              {tenantFamily.length === 0 ? (
                <div>No tenant family found.</div>
              ) : (
                <table className="survey-modal-table">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Role</th>
                      <th>CNIC</th>
                      <th>Phone</th>
                      <th>Age</th>
                      <th>Gender</th>
                      <th>Occupation</th>
                      <th>Income</th>
                      <th>Weapons</th>
                    </tr>
                  </thead>
                  <tbody>
                    {tenantFamily.map((person) => (
                      <tr key={person.id}>
                        <td>
                          {person.first_name} {person.middle_name}{" "}
                          {person.last_name}
                        </td>
                        <td>{person.role_in_property}</td>
                        <td>{person.cnic || "-"}</td>
                        <td>{person.phone_no || "-"}</td>
                        <td>{person.age}</td>
                        <td>{person.gender}</td>
                        <td>{person.occupation_title || "-"}</td>
                        <td>{person.monthly_income || "-"}</td>
                        <td>
                          {person.weapons && person.weapons.length > 0 ? (
                            <ul style={{ margin: 0, paddingLeft: 18 }}>
                              {person.weapons.map((w) => (
                                <li key={w.id} style={{ marginBottom: 4 }}>
                                  {w.type} ({w.license_no}){" "}
                                  {w.is_licensed ? "Licensed" : "Unlicensed"}{" "}
                                  {w.notes && `- ${w.notes}`}
                                </li>
                              ))}
                            </ul>
                          ) : (
                            "None"
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </section>
          </div>
        </div>
        {/* Modal Footer (sticky) */}
        <div className="survey-modal-footer">
          <button className="btn-secondary" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default SurveyViewModal;
